import Reveal from "@/components/Reveal";
import PillarsSection from "@/components/sections/PillarsSection";
import ArchitectureSection from "@/components/sections/ArchitectureSection";
import PracticeImpact from "@/components/sections/PracticeImpact";
import CTABand from "@/components/sections/CTABand";

const evidenceImg =
  "https://static.prod-images.emergentagent.com/jobs/c1a075fa-8b15-42e2-9c19-a7a7f32ee730/images/1ae341ad483067036277ca53b89b48b8ae8da7c9ef805b2bd6af799f68b52d2e.png";

export default function Platform() {
  return (
    <div data-testid="page-platform">
      <section className="bg-ink-0 relative overflow-hidden">
        <div className="absolute inset-0 glow-soft pointer-events-none" aria-hidden="true" />
        <div className="container-edge pt-20 lg:pt-28 pb-20 lg:pb-24 relative z-10">
          <div className="grid grid-cols-12 gap-8">
            <Reveal className="col-span-12 lg:col-span-7">
              <div className="eyebrow">Our practice</div>
              <h1 className="font-serif font-normal text-4xl md:text-5xl lg:text-[5.2rem] leading-[1.05] tracking-tight mt-4 text-parchment-bright">
                One engagement. Patient voice at the centre.
                <span className="block italic text-parchment">Strategy for every relevant function.</span>
              </h1>
              <p className="mt-7 text-parchment/85 text-lg leading-relaxed max-w-2xl">
                Voice2Evidence is an AI-enabled, expert-validated services engagement built around your asset, indication, geography, and lifecycle stage.
              </p>
              <p className="mt-5 text-parchment/75 text-lg leading-relaxed max-w-2xl">
                We translate patient voice into evidence-ready outputs and ready-to-act strategy for the cross-functional teams that depend on it — Medical Affairs, HEOR, Market Access, Regulatory Affairs, Commercial, Patient Engagement, and Leadership.
              </p>
            </Reveal>
            <Reveal className="col-span-12 lg:col-span-5" delay={120}>
              <div className="card-dark p-0 overflow-hidden">
                <img
                  src={evidenceImg}
                  alt="Voice2Evidence"
                  className="w-full aspect-[5/4] object-cover"
                  style={{ filter: "invert(1) hue-rotate(180deg) saturate(0.85) brightness(0.95)" }}
                  data-testid="platform-hero-image"
                />
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <ArchitectureSection />

      <PillarsSection />

      <PracticeImpact />

      <CTABand />
    </div>
  );
}
